import React from 'react';
import './KnowledgePanel.css';

interface KnowledgePanelProps {
  isOpen: boolean;
  onClose: () => void;
  topic: string;
  title: string;
  description: string;
}

const KnowledgePanel: React.FC<KnowledgePanelProps> = ({ 
  isOpen, 
  onClose, 
  topic, 
  title, 
  description 
}) => {
  return (
    <div className={`knowledge-panel ${isOpen ? 'open' : ''}`}>
      <div className="knowledge-panel-overlay" onClick={onClose} />
      <div className="knowledge-panel-content">
        <div className="knowledge-panel-header">
          <div className="knowledge-panel-icon">
            <i className="material-icons">help_outline</i>
          </div>
          <h3 className="knowledge-panel-title">{title}</h3>
          <button className="knowledge-panel-close" onClick={onClose}>
            <i className="material-icons">close</i>
          </button>
        </div>
        <div className="knowledge-panel-body">
          <p className="knowledge-panel-description">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default KnowledgePanel;